module.exports = __webpack_public_path__ + "static/media/twitter.44b4f278.svg";